import React, { useState, useEffect } from 'react';

function TileIcon(props)
{
    const [color, setColor] = useState('#638CA3');

    useEffect(() => {
        if(props.isActive) {
            setColor('#FFFFFF')
        } else if(props.theme !== 'Dark') {
            setColor('#ABBCC5');
        } else {
            setColor('#638CA3');
        }
    }, [props.isActive, props.theme]);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke={color} strokeWidth={2} d="M12 3H5a2 2 0 0 0-2 2v7m9-9h7a2 2 0 0 1 2 2v7m-9-9v18m0 0h7a2 2 0 0 0 2-2v-7m-9 9H5a2 2 0 0 1-2-2v-7m18 0H3" />
        </svg>
    );
}

export default TileIcon;